import { render } from "./MonitoreoFetal.vue?vue&type=template&id=3804ce66&scoped=true"
import script from "./MonitoreoFetal.vue?vue&type=script&lang=js"
export * from "./MonitoreoFetal.vue?vue&type=script&lang=js"

import "./MonitoreoFetal.vue?vue&type=style&index=0&id=3804ce66&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3804ce66"]])

export default __exports__